import React from 'react';

export const AboutSection: React.FC = () => {
  return (
    <section id="sobre" className="py-8 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-4">
            Por que escolher a MãoForte?
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            Conectamos você aos melhores profissionais da construção civil
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-12 items-center">
          {/* Problems Card */}
          <div className="bg-orange-50 border border-orange-200 rounded-xl md:rounded-3xl p-6 md:p-8">
            <div className="flex items-center mb-4 md:mb-6">
              <div className="w-12 h-12 md:w-12 md:h-12 bg-orange-500 rounded-full flex items-center justify-center mr-4 md:mr-4">
                <i className="ri-error-warning-line text-white text-xl md:text-xl"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-orange-700">Problemas Atuais</h3>
            </div>
            <div className="space-y-3 md:space-y-4">
              <div className="flex items-start">
                <div className="w-3 h-3 md:w-3 md:h-3 bg-orange-500 rounded-full mt-2 md:mt-2 mr-3 md:mr-3 flex-shrink-0"></div>
                <div>
                  <span className="text-base md:text-lg text-orange-700 font-medium">Dificuldade para encontrar profissionais</span>
                  <p className="text-sm md:text-base text-orange-600 mt-1">Busca demorada e sem garantias de qualidade</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-3 h-3 md:w-3 md:h-3 bg-orange-500 rounded-full mt-2 md:mt-2 mr-3 md:mr-3 flex-shrink-0"></div>
                <div>
                  <span className="text-base md:text-lg text-orange-700 font-medium">Preços abusivos e sem transparência</span>
                  <p className="text-sm md:text-base text-orange-600 mt-1">Orçamentos inflacionados e custos ocultos</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-3 h-3 md:w-3 md:h-3 bg-orange-500 rounded-full mt-2 md:mt-2 mr-3 md:mr-3 flex-shrink-0"></div>
                <div>
                  <span className="text-base md:text-lg text-orange-700 font-medium">faltas de profissionais para sua equipe </span>
                  <p className="text-sm md:text-base text-orange-600 mt-1">dificuldade de achar pedreiro, eletricista, servente, mão de obra para sua equipe</p>
                </div>
              </div>
            </div>
          </div>

          {/* Solutions Card */}
          <div className="bg-slate-50 border border-slate-200 rounded-xl md:rounded-3xl p-6 md:p-8">
            <div className="flex items-center mb-4 md:mb-6">
              <div className="w-12 h-12 md:w-12 md:h-12 bg-slate-700 rounded-full flex items-center justify-center mr-4 md:mr-4">
                <i className="ri-check-line text-white text-xl md:text-xl"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-slate-700">Nossa Solução</h3>
            </div>
            <div className="space-y-3 md:space-y-4">
              <div className="flex items-start">
                <div className="w-3 h-3 md:w-3 md:h-3 bg-slate-700 rounded-full mt-2 md:mt-2 mr-3 md:mr-3 flex-shrink-0"></div>
                <div>
                  <span className="text-base md:text-lg text-slate-700 font-medium">Profissionais verificados e qualificados</span>
                  <p className="text-sm md:text-base text-slate-600 mt-1">Seleção rigorosa com histórico comprovado</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-3 h-3 md:w-3 md:h-3 bg-slate-700 rounded-full mt-2 md:mt-2 mr-3 md:mr-3 flex-shrink-0"></div>
                <div>
                  <span className="text-base md:text-lg text-slate-700 font-medium">Preços justos e transparentes</span>
                  <p className="text-sm md:text-base text-slate-600 mt-1">Orçamentos detalhados sem surpresas</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-3 h-3 md:w-3 md:h-3 bg-slate-700 rounded-full mt-2 md:mt-2 mr-3 md:mr-3 flex-shrink-0"></div>
                <div>
                  <span className="text-base md:text-lg text-slate-700 font-medium">rede com vários profissionais cadastrado </span>
                  <p className="text-sm md:text-base text-slate-600 mt-1">ache profissionais para sua equipe de forma rápida e com histórico e feedbacks de outros clientes</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
